var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1920",
    width: 120,
    height: 120,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0)",
    d: "m0 0h1920v1920h-1920z",
    fill: "#FFFDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(922,581)",
    d: "m0 0h42l23 3 28 5 29 8 26 9 25 11 27 14 27 18 12 9 13 10 15 14 18 18 9 11 12 15 18 27 14 25 10 21 11 27 10 31 7 30 5 33 2 23v25l-4 30-7 30-7 23-12 33-15 33-9 17-5 9h-3l1 4 8 8 12 16 11 19 8 17 8 24 5 25 1 10v29l-4 24-3 12-8 20-8 16-10 16-9 11-12 13-14 12-8 6-18 11-17 7-18 7-23 3h-34l-14-1-20-5-19-7-17-10-12-8-12-11-10-9-9-11-8-10-10-16-8-18-11-33-1-1-39-1-23-2-26-5-25-7-27-9-28-12-25-13-16-10-18-12-16-12-15-13-6-5v-2l-4-2-14-14v-2h-2l-18-22-14-20-9-14-12-21-13-27-10-26-8-26-6-27-3-22-1-11v-50l3-35 6-30 6-23 8-23 11-26 14-27 9-14 8-12 14-18 18-22 15-15 11-9 10-9 17-13 17-12 21-13 26-13 24-9 20-7 23-6 25-5 24-3z",
    fill: "#3CA587"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1121,1099)",
    d: "m0 0 30 2 20 5 22 8 23 12 16 10 8 6 11 12 13 17 11 19 8 17 8 24 5 25 1 10v29l-4 24-3 12-8 20-8 16-10 16-9 11-12 13-14 12-8 6-18 11-17 7-18 7-23 3h-34l-14-1-20-5-19-7-17-10-12-8-12-11-10-9-9-11-8-10-10-16-8-18-11-33-3-3-1-15 2-38 2-15 6-24 7-16 11-20 16-24 11-13 4-5 13-10 13-8 16-8 14-6 13-4 16-4z",
    fill: "#FE4A52"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(934,744)",
    d: "m0 0 9 1 10 5 6 8 4 13 6 4 23 5 20 8 36 17 5 6-1 7-8 15-11 17-8 15-9 9-4-1-15-10-14-7-18-6h-8v15l1 38 10 3 27 9 29 14 12 8 12 11 9 12 6 11 4 11 2 7 1 14v12l-4 19-6 15-8 14-10 13-8 7-14 8-21 9-33 8-9 4 1 22-1 11-3 6-6 4-15 1-13-1-8-4-4-5v-35l-21-6-18-4-26-8-30-11-19-10-6-4-6-8 1-7 5-9 8-10 8-14 13-17 4-3 6 1 16 8 22 12 18 8 18 7h6l1-4v-52l-16-4-15-5-17-6-19-9-14-10-11-10-10-13-7-14-5-19v-25l4-18 6-16 6-10 8-10 9-9 10-7 17-9 23-8 15-3h10l1-7 5-10 6-7 8-4z",
    fill: "#FFFDFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1051,1178)",
    d: "m0 0 9 1 8 4 7 7 2 5 4 2v2l4 2 9 11 23 23v2l4 2 4 3 5-1 8-7 6-7 8-7 5-5h2l1-3 5-5 7-8 5-5 11-10 8-5 7-1 9 6 1 3 3 1 4 9-1 7-6 12-5 5-8 9-7 8-11 11-3 4h-2l-2 4-7 8-5 5h-2l-1 8 7 8 11 12 5 5 8 9 2 1v2l4 2 16 16 8 11 1 3v7l-5 10-7 6-3 1h-12l-8-4-14-14-3-4v-2l-4-2-7-6-6-7-8-7-10-10-9-5-4 2-7 8-13 13h-2v2l-8 7-11 11-7 9-7 8-8 4-8 1-13-9-4-5-3-6 1-7 8-11 7-7 7-8 9-10 6-7 8-7 8-8 8-7 5-4-1-4-7-9-4-3v-2l-4-2v-2h-2v-2h-2l-4-5-8-7-15-16-10-10-6-5-3-8 1-10 4-5h2l2-4 7-6z",
    fill: "#FFFDFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(958,991)",
    d: "m0 0 9 1 9 4 9 8 2 5-1 8-6 12-7 6-10 3-6-1-3-8-1-18v-16l3-3z",
    fill: "#3CA688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(895,845)",
    d: "m0 0h7l6 4 2 2v11l-1 2-1 23-3 5-4 2-8-3-5-4-8-13v-11l3-8 8-8z",
    fill: "#3CA688"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCross);
export default __webpack_public_path__ + "static/media/dollar_cross.e90f9e66a60daff79c49fc4ff0d9e1f6.svg";
export { ForwardRef as ReactComponent };